const CACHE_KEY = "sf-hi-v1";
const SPOKEN = {
  Home: "होम",
  About: "हमारे बारे में",
  Benefits: "फायदे",
  Pricing: "कीमत",
  "Pricing · Coming soon": "कीमत · जल्द आएगी",
  Contact: "संपर्क",
  "Contact us": "संपर्क करें",
  App: "ऐप",
  More: "और",
  Login: "लॉगिन",
  "See benefits": "फायदे देखें",
  "See pricing": "कीमत देखें",
  Accounts: "अकाउंट",
  ACCOUNTS: "अकाउंट",
  Devices: "डिवाइस",
  Sensors: "सेंसर",
  History: "हिस्ट्री",
  Notifications: "नोटिफिकेशन",
  Alerts: "अलर्ट",
  Settings: "सेटिंग्स",
  Profile: "प्रोफाइल",
  Roadmap: "रोडमैप",
  Dashboard: "डैशबोर्ड",
  "Privacy Policy": "प्राइवेसी पॉलिसी",
  "Board Wi-Fi": "बोर्ड वाई-फाई",
  "Noida, India": "नोएडा, भारत",
  "Noida · small plots": "नोएडा · छोटे प्लॉट",
  "2.4 GHz": "2.4 GHz",
  "2.4 GHz only": "सिर्फ 2.4 GHz",
  "Check the soil before you water.": "पानी देने से पहले मिट्टी चेक कर लो।",
  "A board in the plot sends soil moisture, air temperature, and humidity to this app. From the same screen you can turn a pump on or off, or leave a moisture rule to do it.": "प्लॉट वाला बोर्ड मिट्टी की नमी, तापमान और हवा की नमी इस ऐप पर भेजता है। उसी स्क्रीन से पंप चालू या बंद कर सकते हो, और नमी कम हो तो पंप अपने आप चल सकता है।",
  "Readings, history, alerts, and the pump.": "रीडिंग, हिस्ट्री, अलर्ट और पंप।",
  "The cards below are the jobs on the dashboard. A weather forecast and a camera are not among them.": "नीचे वाले कार्ड डैशबोर्ड के काम हैं। मौसम और कैमरा अभी ऐप में नहीं हैं।",
  "The pump sits next to the reading.": "पंप रीडिंग के साथ ही है।",
  "If the board has a relay, the dashboard can start the pump, stop it, run it for a set number of minutes, or start it when soil moisture drops under a number you set.": "बोर्ड पर रिले हो तो डैशबोर्ड से पंप चालू करो, बंद करो, कुछ मिनट चलाओ, या नमी एक नंबर से नीचे जाए तो अपने आप चालू हो जाए।",
  "The ESP8266 board cannot join a 5 GHz network. You send the network name from Settings.": "ESP8266 बोर्ड 5 GHz नेटवर्क पर नहीं चलता। वाई-फाई का नाम सेटिंग्स से भेजो।",
  "The dashboard requires sign-in. A device is stored on the account that added it.": "डैशबोर्ड के लिए लॉगिन चाहिए। डिवाइस उसी अकाउंट में रहता है जिसने जोड़ा।",
  "Your account": "तुम्हारा अकाउंट",
  "Want a board on a plot?": "प्लॉट पर बोर्ड चाहिए?",
  "Write with the plot size and whether you already have a pump. Aryan and Chetan reply from Noida.": "प्लॉट का साइज लिखो, और बताओ पंप पहले से है या नहीं। आर्यन और चेतन नोएडा से जवाब देते हैं।",
  "What a node does today.": "नोड अभी क्या करता है।",
  "Notes on the board and the app. These are not customer stories.": "बोर्ड और ऐप के नोट्स। ये किसी ग्राहक की कहानी नहीं हैं।",
  "Common questions": "आम सवाल",
  "Not a live plot": "ये लाइव प्लॉट नहीं है",
  "Example card": "उदाहरण",
  Sample: "सैंपल",
  "Live readings": "लाइव रीडिंग",
  "Soil moisture, air temperature, and humidity from each board that is online.": "जो बोर्ड ऑनलाइन है, उससे मिट्टी की नमी, तापमान और हवा की नमी।",
  "Charts of past readings, and a CSV download from the history page.": "पुरानी रीडिंग के चार्ट, और हिस्ट्री पेज से CSV डाउनलोड।",
  "Set a limit for temperature, humidity, or soil moisture. The app stores an alert when a reading crosses it.": "तापमान, हवा की नमी या मिट्टी की नमी की लिमिट लगाओ। रीडिंग उस लिमिट के पार जाए तो ऐप अलर्ट सेव करता है।",
  "Devices and Wi-Fi": "डिवाइस और वाई-फाई",
  "Rename a device, see when it was last online, and push a 2.4 GHz network from Settings.": "डिवाइस का नाम बदलो, आखिरी बार कब ऑनलाइन था वो देखो, और सेटिंग्स से 2.4 GHz नेटवर्क भेजो।",
  "Why does a metric show N/A?": "N/A क्यों दिखता है?",
  "The board is offline, or it has not sent a reading in the current window. Open the device and check the last time it was seen.": "बोर्ड ऑफलाइन है, या इस बार रीडिंग नहीं आई। डिवाइस खोलो और देखो आखिरी बार कब दिखा था।",
  "How often do the numbers update?": "नंबर कितनी बार अपडेट होते हैं?",
  "The live cards follow the latest message from the board. Charts on the history page are grouped so a long range stays readable.": "लाइव कार्ड बोर्ड का आखिरी मैसेज दिखाते हैं। हिस्ट्री के चार्ट लंबे समय के लिए जोड़कर दिखाए जाते हैं, ताकि पढ़ने में आसान रहें।",
  "Where do I change the Wi-Fi?": "वाई-फाई कहां बदलूं?",
  "Open Settings, pick the device, then Wi-Fi. The ESP8266 board only joins 2.4 GHz networks.": "सेटिंग्स खोलो, डिवाइस चुनो, फिर वाई-फाई। ESP8266 बोर्ड सिर्फ 2.4 GHz नेटवर्क पर चलता है।",
  "Can the pump run by itself?": "क्या पंप अपने आप चल सकता है?",
  "Yes, on a device that has a relay. You can start and stop it by hand, set a timer, or set a soil-moisture rule.": "हां, जिस डिवाइस पर रिले हो। हाथ से चालू-बंद करो, टाइमर लगाओ, या मिट्टी की नमी का नियम सेट करो।",
  "Three readings from one probe": "एक प्रोब से तीन रीडिंग",
  "The board reports soil moisture, air temperature, and humidity. The dashboard keeps the latest value and a history you can open later.": "बोर्ड मिट्टी की नमी, तापमान और हवा की नमी भेजता है। डैशबोर्ड आखिरी वैल्यू और पुरानी हिस्ट्री रखता है।",
  "The pump is controlled from the phone": "पंप फोन से चलता है",
  "If the node has a relay, you can turn the pump on or off, run it for a set number of minutes, or start it when soil moisture drops under a number you choose. A run is stored with the sensor values from when it started.": "नोड पर रिले हो तो पंप चालू या बंद करो, कुछ मिनट चलाओ, या मिट्टी की नमी तुम्हारे नंबर से नीचे जाए तो चालू हो जाए। हर बार की रीडिंग सेव हो जाती है।",
  "One plot, one board, one pump": "एक प्लॉट, एक बोर्ड, एक पंप",
  "The first setup is a single growing area. Terrace growers and small nurseries in India are who this is for. It is not a system for a large estate.": "शुरुआत एक प्लॉट के लिए है। छत पर उगाते हो या छोटी नर्सरी है, उनके लिए है। बड़े फार्म के लिए नहीं।",
  "Soil moisture, air temperature, and humidity, plus pump control, for small plots. Based in Noida.": "छोटे प्लॉट के लिए मिट्टी की नमी, तापमान, हवा की नमी और पंप कंट्रोल। नोएडा से।",
};

function speak(text) {
  return text.replace(/गीगाहर्ट्[ज़ज़ज]/g, "GHz");
}
const memory = loadCache();
Object.entries(SPOKEN).forEach(([key, value]) => {
  memory[normalize(key)] = value;
});

function loadCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function saveCache() {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(memory));
  } catch {
    // A full cache should not block the page.
  }
}

function normalize(value) {
  return String(value || "").replace(/\s+/g, " ").trim();
}

function phraseText(el) {
  return normalize(
    textNodesIn(el)
      .map((node) => node.nodeValue)
      .filter(Boolean)
      .join(" ")
  );
}

export function needsHindi(value) {
  const text = normalize(value);
  const letters = text.replace(/[^A-Za-z]/g, "");
  if (letters.length < 2 || text.length > 900) return false;
  if (/^https?:\/\//i.test(text)) return false;
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text)) return false;
  if (/^\+?\d[\d\s()-]{6,}$/.test(text)) return false;
  return true;
}

const INLINE_TAGS = new Set(["SPAN", "EM", "STRONG", "I", "B", "BR", "SMALL", "MARK", "ABBR", "CITE", "WBR"]);

function textNodesIn(el) {
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent || parent.closest("svg") || parent.tagName === "SCRIPT" || parent.tagName === "STYLE") {
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    },
  });
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}

function phraseElements(root) {
  const elements = [...root.querySelectorAll("*")].filter((el) => {
    if (el.closest("[data-no-translate]") || el.closest("svg")) return false;
    if (el.tagName === "SCRIPT" || el.tagName === "STYLE" || el.tagName === "NOSCRIPT" || el.tagName === "TEXTAREA") {
      return false;
    }
    if (!needsHindi(phraseText(el))) return false;
    const hasSeparateChild = [...el.children].some(
      (child) => child.tagName !== "SVG" && !child.closest("svg") && !INLINE_TAGS.has(child.tagName)
    );
    return !hasSeparateChild;
  });
  return elements.filter((el) => !elements.some((other) => other !== el && other.contains(el)));
}

function collectPlaceholders(root) {
  return [...root.querySelectorAll("[placeholder]")].filter((el) => {
    if (el.closest("[data-no-translate]")) return false;
    if (!el.dataset.sfPh) el.dataset.sfPh = el.getAttribute("placeholder") || "";
    return needsHindi(el.dataset.sfPh);
  });
}

async function translateOne(text) {
  const key = normalize(text);
  if (SPOKEN[key]) {
    memory[key] = SPOKEN[key];
    return memory[key];
  }
  if (memory[key]) return speak(memory[key]);
  const url = new URL("https://translate.googleapis.com/translate_a/single");
  url.searchParams.set("client", "gtx");
  url.searchParams.set("sl", "en");
  url.searchParams.set("tl", "hi");
  url.searchParams.set("dt", "t");
  url.searchParams.set("q", key);
  const response = await fetch(url.toString());
  if (!response.ok) throw new Error("Hindi translation failed");
  const data = await response.json();
  const parts = Array.isArray(data?.[0]) ? data[0] : [];
  const translated = parts
    .filter((part) => Array.isArray(part) && typeof part[0] === "string")
    .map((part) => normalize(part[0]))
    .filter(Boolean)
    .join(" ");
  if (translated) memory[key] = speak(translated);
  return memory[key] || key;
}

async function translateAll(values) {
  const missing = [...new Set(values.map(normalize).filter((value) => needsHindi(value) && !memory[value]))];
  let cursor = 0;
  async function worker() {
    while (cursor < missing.length) {
      const index = cursor;
      cursor += 1;
      try {
        await translateOne(missing[index]);
      } catch {
        // Leave that string in English if the request fails.
      }
    }
  }
  const workers = Math.min(5, missing.length);
  await Promise.all(Array.from({ length: workers }, () => worker()));
  if (missing.length) saveCache();
}

function rememberEnglish(el) {
  const current = phraseText(el);
  const stored = el.dataset.sfFull;
  const translated = stored ? memory[stored] : "";
  if (stored && (current === stored || current === translated)) return stored;
  const nodes = textNodesIn(el);
  if (!nodes.length) return current;
  el.dataset.sfParts = JSON.stringify(nodes.map((node) => node.nodeValue));
  el.dataset.sfFull = current;
  return current;
}

function paintElement(el) {
  const source = rememberEnglish(el);
  const translated = memory[source];
  if (!translated || translated === source || phraseText(el) === translated) return;
  const nodes = textNodesIn(el);
  const wordIndexes = nodes
    .map((node, index) => (node.nodeValue && node.nodeValue.trim() ? index : -1))
    .filter((index) => index >= 0);
  if (!wordIndexes.length) return;
  wordIndexes.forEach((nodeIndex, position) => {
    nodes[nodeIndex].nodeValue = position === 0 ? translated : "";
  });
}

let applying = false;

export async function applyHindi(root = document.body) {
  if (applying || !root) return;
  applying = true;
  try {
    const elements = phraseElements(root);
    const placeholders = collectPlaceholders(root);
    await translateAll([
      ...elements.map((el) => rememberEnglish(el)),
      ...placeholders.map((el) => el.dataset.sfPh || ""),
    ]);
    elements.forEach(paintElement);
    placeholders.forEach((el) => {
      const key = normalize(el.dataset.sfPh);
      if (memory[key]) el.setAttribute("placeholder", memory[key]);
    });
  } finally {
    applying = false;
  }
}

export function restoreEnglish() {
  document.querySelectorAll("[data-sf-parts]").forEach((el) => {
    let parts = [];
    try {
      parts = JSON.parse(el.dataset.sfParts || "[]");
    } catch {
      parts = [];
    }
    const nodes = textNodesIn(el);
    parts.forEach((part, index) => {
      if (nodes[index]) nodes[index].nodeValue = part;
    });
    delete el.dataset.sfParts;
    delete el.dataset.sfFull;
  });
  document.querySelectorAll("[data-sf-ph]").forEach((el) => {
    el.setAttribute("placeholder", el.dataset.sfPh || "");
    delete el.dataset.sfPh;
  });
}
